import service from '../../utils/request'
import allUrl from "../../utils/setUrl"
import setting from '../../utils/setting';
//通过level分别查询教学中心或分部
export function getSchoolByLevel(data){
  return service({
    baseURL: setting.baseOtherTwoUrl,
    url:allUrl.edu+'/indexnews/getNewsByMenuName',
    method:"post",
    data
  })
}
//通过level分别查询教学中心或分部-新
export function couschoolGetSchoolList(data){
  return service({
    baseURL: setting.baseOtherTwoUrl,
    url:allUrl.enroll+'/couschool/getSchoolList',
    method:"post",
    data
  })
}
//获取学校详情-新
export function couschoolGetBranchIntroductionByOrgId(params){
  return service({
    baseURL: setting.baseOtherTwoUrl,
    url:allUrl.enroll+`couschool/getBranchIntroductionByOrgId`,
    method:"get",
    params:params
  })
}
//获取招生专业
export function getSchoolSpecialZs(params){
  return service({
      url:allUrl.home+'/schoolSpecialty/getSchoolSpecialZs',
      method:"get",
      params
  })
}

//获取学校详情
export function getNewsById(params){
  return service({
    baseURL: setting.baseOtherTwoUrl,
    url:allUrl.edu+'/indexnews/getNewsById',
    method:"post",
    params
  })
}


